import { render, staticRenderFns } from "./AppModalOrder.vue?vue&type=template&id=5536d16e&"
import script from "./AppModalOrder.vue?vue&type=script&lang=js&"
export * from "./AppModalOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports